<app-loading-indicator class="dialog-loader__indicator" />
